import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectEntitiesByFilters } from '../../../shared/store/views/entityView';
import { bgtCoursesFilters } from '../../../shared/utils/entitiesFiltersUtils';
import MyCourseItem from '../../../shared/components/features/courseItem/myCourseItem/MyCourseItem';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import Widget from '../../../shared/components/features/widget/Widget';
import Page from '../../../shared/components/ui/page/Page';
import pathRouts from '../../../shared/enums/pathRoute';
import classes from './BgtPage.module.css';
import PageHeader from '../../../shared/components/features/PageHeader.js/PageHeader';

const BgtPage = () => {

    const { texts } = useSelector(state => state.translate);
    const navigate = useNavigate();
    const myMatriculation = useSelector(state => selectEntitiesByFilters(state, bgtCoursesFilters));

    return (
        <Page title={texts.bgt} icon={iconsList.bgt} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.BgtPage}>
                <PageHeader text={texts.bgt} />
                <div className={classes.Content}>
                    <div className={classes.TopPart}>
                        <Widget
                            icon={iconsList.bgt}
                            color="#FDDB71"
                            title={texts.bgt}
                            height={525}
                            width={525}
                            className={classes.bgtWidget}
                        >
                            <div className={classes.WidgetContent}>
                                <div className={classes.CoursesList}>
                                    {myMatriculation?.length > 0 ?
                                        myMatriculation?.map(matriculation => (
                                            <MyCourseItem key={matriculation.id} course={matriculation} />
                                        ))
                                        :
                                        <div className={classes.NoBgtCourses}>{texts.noBgtCourses}</div>
                                    }
                                </div>
                            </div>
                        </Widget>
                    </div>
                </div>
            </div>
        </Page>
    );
}
export default BgtPage;